import Joi from 'joi';
import PropTypes from 'prop-types';

import { Column } from '../../../../utils/models';

import Form from '../../../common/form';

class PECReadingForm extends Form {
	state = {
		data: {},
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onAdd: PropTypes.func,
		columns: PropTypes.array,
	};


	mapData = () => {
		const data: any = {};
		const schema: any = {};

		const columns = this.props.columns;
		for (const column of columns) {
			if (column.path === 'srNo') {
				schema[column.path] = Joi.number().required().label(column.path);
			} else {
				schema[column.path] = Joi.alternatives().try(Joi.number().min(0), Joi.string().valid('N/A', 'R/A').insensitive()).required().label(column.path);
			}

			data[column.path] = '';
		}

		this.schema = schema;
		this.setState({ data } as any);
	};

	componentDidMount(): void {
		this.mapData();
	}

	componentDidUpdate(prevProps: any, prevState: any) {
		const columns = this.props.columns ?? [];
		const prevColumns = prevProps.columns ?? [];

		if (columns !== prevColumns) {
			this.mapData();
		}
	}

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);
		this.mapData();
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h2 className="form-title">Scan Data Readings</h2>

				<div className="row">
					{this.props.columns.map((column: Column) => (
						<div key={column.path} className="col">
							{this.renderInput({
								type: 'text',
								name: column.path,
								placeholder: 'Enter ' + column.label,
								label: column.label,
							})}
						</div>
					))}
				</div>

				{this.renderButton('Add Item')}
			</form>
		);
	}
}

export default PECReadingForm;
